import React from "react";

const HeroItemSkeleton: React.FC = () => {
  return (
    <div className="w-full">
      <div className="relative min-h-[600px] overflow-hidden grid place-items-end">
        <div className="absolute w-full h-full">
          <div className="relative w-full h-full">
            <div className="absolute bg-gradient-to-t from-black/70 to-black/25 w-full h-full min-h-[660px]"></div>
          </div>
        </div>
        <div className="container mx-auto py-20 z-[2] max-w-[85vw]">
          <h1 className="skeleton max-sm:!rounded text-5xl font-bold font-mikado-regular mb-4 truncate break-words text-wrap max-md:max-w-md max-sm:max-w-xs bg-gray-50 w-96 h-14"></h1>
          <p className="skeleton max-sm:!rounded-sm !rounded-sm font-mikado-regular text-2xl my-[15px] max-sm:my-[5px] max-sm:h-5  break-words line-clamp-3 bg-gray-50 w-full h-5"></p>
          <p className="skeleton max-sm:!rounded-sm !rounded-sm font-mikado-regular text-2xl my-[15px] max-sm:my-[5px] max-sm:h-5  break-words line-clamp-3 bg-gray-50 w-full h-5"></p>
          <p className="skeleton max-sm:!rounded-sm !rounded-sm font-mikado-regular text-2xl my-[15px]  max-sm:my-[5px] max-sm:h-5 break-words line-clamp-3 bg-gray-50 w-full h-5"></p>

          <div className="my-4 flex items-center gap-3 max-sm:gap-3 flex-wrap max-sm:flex-col">
            <button
              onClick={(e) => {
                e.preventDefault();
              }}
              className="bg-gray-50 skeleton w-48 !rounded-2xl h-16 max-sm:mb-4 max-sm:w-full max-sm:!rounded-md"
            ></button>
            <button className=" bg-gray-50 skeleton w-48 !rounded-full h-16 max-sm:h-10 max-sm:w-full max-sm:!rounded-full">
              <span></span>
            </button>
          </div>
          <div className="flex gap-10 flex-wrap max-sm:flex-col max-sm:gap-5">
            <h4 className=" bg-gray-50 skeleton max-sm:!rounded-sm font-mikado-regular font-bold text-2xl h-9 w-80 max-sm:w-80 max-sm:h-7"></h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroItemSkeleton;
